import React from 'react'
import { NavLink } from 'react-router-dom'
import {
  formatPublicationDate,
  getArticlePrimaryImage,
} from '../../api/newsArticleApi'

const NewsArticleCards = ({ article }) => {
  const imageUrl = getArticlePrimaryImage(article)
  const authorName = article?.provider_name || ''
  const platform = article?.publication_name || article?.publication_platform || ''
  const publishedDate = formatPublicationDate(article?.publication_date)
  const heading = authorName || platform || article?.title || 'News & Media'

  return (
    <div className="news-article-card p-3 rounded-xl shadow-md second-bg h-100 d-flex flex-column">
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={heading}
          className="w-full object-cover news-article-card__image"
        />
      ) : (
        <div className="news-article-card__image news-article-card__no-image">
          No image
        </div>
      )}
      <div className="py-3 px-1 flex-grow-1">
        <div className="flex items-start">
          <h5 className="lg:text-[18px] text-gray-900 font-semibold mb-2">
            {heading}
          </h5>
        </div>
        <div className="d-flex flex-wrap align-items-center gap-2">
          {authorName && platform ? (
            <div className="text-[14px] text-gray-600">{platform}</div>
          ) : null}
          {publishedDate && (
            <div className="text-gray-600 text-[14px]">{publishedDate}</div>
          )}
        </div>
      </div>
      <div className="mt-auto">
        <NavLink
          className="text-[18px] text-gray-900 hover:text-[#cda202] transition-shadow text-decoration-none d-inline"
          to={`/news-articles/${article.article_id}`}
          state={article}
        >
          Read More
        </NavLink>
      </div>
    </div>
  )
}

export default NewsArticleCards
